import api from '../utils/api';

export const landService = {
    getDashboardStats: async (fy, subCountyId) => {
        const response = await api.get('/land/dashboard', {
            params: { fy, subCountyId }
        });
        return response.data;
    }
};